import type { Achievement } from "../achievement.types";

// Awarded from the atlas's `seen` count: see ../atlasAchievements.ts.
export const surveyorAchievement: Achievement = {
  id: "surveyor",
  name: "Surveyor",
  description: "Mapped a thousand of her words.",
  icon: "map-marker-radius",
  check: () => false,
};
